import { useCallback } from "react";

import { define, prop, useHTMLClassnames } from "@/components/builder/utils";
import RootBackground from "@/components/builder/utils/RootBackground";
import { useStorePartials } from '@/modules/cms/views/post/components/builder/context'

import { PartialHTML } from "./Partial";

function LayoutRootPreview({ children, ...props }) {
  useHTMLClassnames(props)

  return <RootBackground>
    {children}
  </RootBackground>
}

function LayoutRootHTML({ head, attributes: { className } = {}, children }) {
  return <>
    {'<!doctype html>'}
    <html lang="en">
      <PartialHTML path={head} />
      <body className={className}>
        {children}
      </body>
    </html >
  </>
}

export function usePartialOptions() {
  const { items } = useStorePartials()

  return useCallback(async () => ({
    options: items.map(({ name, definition, id }) => ({
      value: name,
      label: name,
      meta: { definition, id },
    })),
  }), [items])
}

export default define('layout_root', LayoutRootPreview, LayoutRootHTML)
  .property(prop.predefined.customClass().label('Body Class'))
  .property(prop.select.async('Head', 'head')
    .props({
      useOptions: usePartialOptions,
    }))
  .build()
